import DateRangeDestructor from './src/main.vue';

DateRangeDestructor.install = function (Vue) {
  Vue.component(DateRangeDestructor.name, DateRangeDestructor);
}

export default DateRangeDestructor;
